import React, { PureComponent } from 'react'
import CSSModules from 'react-css-modules'
import PropTypes from 'prop-types'
import Isvg from 'react-inlinesvg'
import classNames from 'classnames'

import styles from './videoNppFooter.scss'
import PlayIcon from 'assets/components/npp/video_npp_footer/npp_play.svg'
import AddTo from 'assets/components/npp/video_npp_footer/add-to.svg'
import PreviewIcon from 'assets/components/npp/video_npp_footer/npp_preview.svg'
import PlayIconYoutube from 'assets/components/npp/video_npp_footer/npp_play_youtube.svg'
import PlayIconYoutubeHover from 'assets/components/npp/video_npp_footer/npp_play_youtube_hover.svg'


class VideoFooter extends PureComponent {

	getIcon() {
		if (this.props.isFromYoutube) {
			if (this.props.hover) {
				return PlayIconYoutubeHover
			}
			return PlayIconYoutube
		}
		return PlayIcon
	}

	getSvg() {
		if (!(!!this.props.duration)) {
			return null
		}

		return (
			<Isvg
				src={this.getIcon()}
				cacheGetRequests={true}
				styleName={classNames({
					'play-button-icon': true,
					'play-button-icon-youtube': this.props.isFromYoutube,
					'play-button-icon-youtube--hover': this.props.hover && this.props.isFromYoutube,
				})}
			/>
		)
	}

	render() {
		return (
			<div styleName="wrapper">
				<a styleName="controls" onClick={this.props.handleNppThumbnailSelection}>
					<button styleName={
						classNames({
							'play-button': true,
							'play-button--hover': this.props.hover,
							'play-button--hover-youtube': this.props.hover && this.props.isFromYoutube,
						})}
					>
						{this.getSvg()}
					</button>
					<div styleName="time">{this.props.duration}</div>
				</a>

				{ this.props.hover &&
					<div styleName="actions">
						<button styleName='actions-preview'>
							<Isvg src={PreviewIcon} cacheGetRequests={true} styleName='actions-preview-icon' />
						</button>
						{ this.props.canAddToMyLibrary &&
							<button onClick={this.props.addVideoProduct} styleName='actions-add-to'>
								<Isvg src={AddTo} cacheGetRequests={true} styleName='actions-add-to-icon' />
							</button>
						}
					</div>
				}
			</div>
		)
	}
}

VideoFooter.propTypes = {
	hover: PropTypes.bool,
	canAddToMyLibrary: PropTypes.bool,
	addVideoProduct: PropTypes.func,
	handleNppThumbnailSelection: PropTypes.func,
	duration: PropTypes.string,
	isFromYoutube: PropTypes.bool,
}

VideoFooter.defaultProps = {
	hover: false,
	canAddToMyLibrary: false,
	addVideoProduct: () => {},
	handleNppThumbnailSelection: () => {},
	isFromYoutube: false,
}

export default CSSModules(VideoFooter, styles, { allowMultiple: true })
